import { Banner } from '@repo/ui';
import MedsImage from 'assets/images/partner-recs/meds.svg?react';
import useGetMobilePartnerNotesItems from 'hooks/partnerNotes/mobile/useGetMobilePartnerNotesItems';
import { useNavigate } from 'react-router-dom';
import styles from './PartnerRecsBanner.module.css';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';

function MedsIcon() {
  return (
    <div className={styles.iconContainer}>
      <MedsImage className={styles.icon} />
    </div>
  );
}

export default function PartnerRecsBanner() {
  const [firstPartnerNote] = useGetMobilePartnerNotesItems();
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();

  if (!firstPartnerNote) return null;

  function handleClick() {
    trackEvent('Partner Recs Banner Clicked');
    navigate(`/partner-recs/${firstPartnerNote.partner.id}`);
  }

  return (
    <Banner
      color='purple'
      content={`View recommendations from ${firstPartnerNote.partner.name}`}
      variant='simple'
      icon={MedsIcon}
      action={{
        label: 'View',
        onClick: handleClick,
      }}
    />
  );
}
